import { useState } from "react";
import BaseDialog from "../../modelDialogs/BaseDialog";
import BaseModel from "../../models/BaseModel";
import { itx } from "../../translationItx/itx";
import ObjectReference from "../ObjectReference";
import "./ShowErrorsToUsersOutsideOfDevelopment.scss";

export default function openShowErrorsToUsersOutsideOfDevelopment() {
  const toShowErrors = new Map<string, Array<BaseModel>>();

  let count = 0;

  state.consistencyCheckLog.forEach((err) => {
    const obj = state.objectRegistry.getObject(err.id) as BaseModel;
    const userErrorMessage = err.userError || "";
    if (userErrorMessage && userErrorMessage != "" && obj) {
      const errorSet = toShowErrors.get(userErrorMessage) || [];
      errorSet.push(obj);
      toShowErrors.set(userErrorMessage, errorSet);
      count++;
    }
  });

  if (toShowErrors.size > 0) {
    state.dialogManager.openDialog(
      <BaseDialog
        title={itx("ShowErrorsToUsersOutsideOfDevelopment.title", "T1 Fehler im Projekt", {
          T1: `${count}`,
        })}
        noAbortButton={true}
      >
        <ShowErrorsToUsersOutsideOfDevelopmentElement groupedErrors={toShowErrors} />{" "}
      </BaseDialog>,
      false,
      false,
    );
  }
}

export function ShowErrorsToUsersOutsideOfDevelopmentElement(props: { groupedErrors: Map<string, Array<BaseModel>> }) {
  const { groupedErrors } = props;

  function ErrorElement(props: { value: Array<BaseModel>; errorKey: string }) {
    const { value, errorKey } = props;
    const [isOpen, setIsOpen] = useState(false);
    const count = value.length;

    return (
      <div className="showErrorsDialogGroup">
        <div className={`showErrorsDialogGroupHeader ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}>
          <button
            type="button"
            className="showErrorsDialogToggle"
            onClick={(ev) => {
              ev.stopPropagation();
              setIsOpen(!isOpen);
            }}
            aria-expanded={isOpen}
            aria-label={itx("ShowErrorsToUsersOutsideOfDevelopment.toggle", "Fehlergruppe auf- oder zuklappen")}
          >
            <i className={isOpen ? "las la-caret-down" : "las la-caret-right"} />
          </button>
          <div className="showErrorsDialogGroupTitle">
            <span>{itx("ShowErrorsToUsersOutsideOfDevelopment." + errorKey, errorKey, { T1: `${count}` })}</span>
          </div>
        </div>
        {isOpen && (
          <div className="showErrorsDialogEntries">
            {value.map((v, i) => (
              <div key={`${errorKey}_${i}`} className="showErrorsDialogEntry">
                <ObjectReference
                  className="showErrorsDialogObjectReference"
                  style={{
                    width: "initial",
                    minWidth: "100px",
                  }}
                  obj={v}
                  showName={true}
                  useSimpleFulltag={true}
                  useAllwaysMaxSpace={false}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
  if (groupedErrors.size === 0) {
    return null;
  }

  return (
    <div className="showErrorsDialogRoot">
      {groupedErrors.size === 0 ? (
        <div className="showErrorsDialogEmpty">
          {itx("ShowErrorsToUsersOutsideOfDevelopment.noErrors", "Keine Fehler gefunden.")}
        </div>
      ) : (
        [...groupedErrors].map(([errorKey, value]) => {
          return <ErrorElement key={errorKey} errorKey={errorKey} value={value} />;
        })
      )}
    </div>
  );
}
